
import React, { useEffect, useState } from "react";
import axios from "axios";
import hostlink from "../Hostlink/hostlink";
import { toast } from "react-toastify";

const EmployeeAttendance = () => {

    // =========================================================
    // SHOP ID
    // =========================================================
    const shopData = localStorage.getItem("MYPCKARTUSER");

    const shopid = shopData
        ? JSON.parse(shopData)[0]?.id
        : "0";


    // =========================================================
    // STATES
    // =========================================================
    const [employees, setEmployees] = useState([]);

    const [attendance, setAttendance] = useState({});

    const [date, setDate] = useState(
        new Date().toISOString().split("T")[0]
    );

    const [holidayName, setHolidayName] = useState("");

    const [loading, setLoading] = useState(false);

    const [savingId, setSavingId] = useState(null);

    const [savingHoliday, setSavingHoliday] = useState(false);


    // =========================================================
    // LOAD EMPLOYEES
    // =========================================================
    useEffect(() => {

        if (shopid && Number(shopid) !== 0) {
            loadEmployees();
        }

    }, [shopid]);


    // =========================================================
    // LOAD ATTENDANCE WHEN DATE / EMPLOYEES CHANGE
    // =========================================================
    useEffect(() => {

        if (
            employees.length > 0 &&
            date
        ) {
            loadAttendance();
        }

    }, [date, employees.length]);


    // =========================================================
    // LOAD EMPLOYEES API
    // =========================================================
    const loadEmployees = async () => {

        try {

            setLoading(true);

            const response = await axios.get(
                `${hostlink}/list/${shopid}`
            );

            setEmployees(response.data || []);

        } catch (error) {

            console.error(error);

            toast.error(
                "Unable to load employees"
            );

        } finally {

            setLoading(false);

        }
    };


    // =========================================================
    // LOAD DATE-WISE ATTENDANCE
    // =========================================================
    const loadAttendance = async () => {

        try {

            setLoading(true);

            const response = await axios.get(
                `${hostlink}/employee-attendance/date`,
                {
                    params: {
                        shopid,
                        date
                    }
                }
            );

            const map = {};

            let foundHoliday = "";

            (response.data || []).forEach(item => {

                map[item.employeeid] = {

                    status: item.status || "",

                    intime: item.intime || "",

                    outtime: item.outtime || "",

                    narration: item.narration || ""

                };


                // Get holiday name from saved narration
                if (
                    item.status === "HOLIDAY" &&
                    item.narration
                ) {
                    foundHoliday = item.narration;
                }

            });


            setAttendance(map);

            setHolidayName(foundHoliday);

        } catch (error) {

            console.error(error);

            toast.error(
                "Unable to load attendance"
            );

        } finally {

            setLoading(false);

        }
    };


    // =========================================================
    // UPDATE ATTENDANCE FIELD
    // =========================================================
    const updateAttendanceField = (
        employeeId,
        field,
        value
    ) => {

        setAttendance(prev => ({

            ...prev,

            [employeeId]: {

                ...(prev[employeeId] || {}),

                [field]: value

            }

        }));

    };


    // =========================================================
    // SELECT STATUS
    // =========================================================
    const selectStatus = (
        employeeId,
        status
    ) => {

        setAttendance(prev => ({

            ...prev,

            [employeeId]: {

                ...(prev[employeeId] || {}),

                status,

                // Clear time if not PRESENT
                ...(status !== "PRESENT"
                    ? {
                        intime: "",
                        outtime: ""
                    }
                    : {})

            }

        }));

    };


    // =========================================================
    // SAVE SINGLE EMPLOYEE
    // =========================================================
    const saveEmployeeAttendance = async (
        employee
    ) => {

        const current =
            attendance[employee.id] || {};


        // -----------------------------------------
        // STATUS REQUIRED
        // -----------------------------------------
        if (!current.status) {

            toast.warning(
                `Please select attendance status for ${employee.accname}`
            );

            return;
        }


        // -----------------------------------------
        // PRESENT REQUIRES TIME
        // -----------------------------------------
        if (
            current.status === "PRESENT" &&
            (
                !current.intime ||
                !current.outtime
            )
        ) {

            // toast.warning(
            //     `Please enter In Time and Out Time for ${employee.accname}`
            // );

            // return;
        }


        // -----------------------------------------
        // VALIDATE TIME
        // -----------------------------------------
        if (
            current.intime &&
            current.outtime &&
            current.outtime <= current.intime
        ) {

            // toast.warning(
            //     "Out Time must be greater than In Time"
            // );

            // return;
        }


        try {

            setSavingId(employee.id);


            const data = {

                employeeid: employee.id,

                shopid: Number(shopid),

                attendancedate: date,

                status: current.status,

                intime:
                    current.intime || "",

                outtime:
                    current.outtime || "",

                narration:
                    current.narration || ""

            };


            const response = await axios.post(

                `${hostlink}/employee-attendance/save`,

                data

            );


            const saved =
                response.data || data;


            setAttendance(prev => ({

                ...prev,

                [employee.id]: {

                    status:
                        saved.status ||
                        current.status,

                    intime:
                        saved.intime ||
                        current.intime ||
                        "",

                    outtime:
                        saved.outtime ||
                        current.outtime ||
                        "",

                    narration:
                        saved.narration ||
                        current.narration ||
                        ""

                }

            }));


            toast.success(
                `${employee.accname} attendance saved`
            );


        } catch (error) {

            console.error(error);

            toast.error(
                "Unable to save attendance"
            );

        } finally {

            setSavingId(null);

        }

    };


    // =========================================================
    // MARK ALL EMPLOYEES AS HOLIDAY
    // =========================================================
    const markAllHoliday = async () => {

        if (!date) {

            toast.warning(
                "Please select attendance date"
            );

            return;
        }


        if (employees.length === 0) {

            toast.warning(
                "No employees found"
            );

            return;
        }


        if (!holidayName.trim()) {

            toast.warning(
                "Please enter holiday name"
            );

            return;
        }


        const confirmed =
            window.confirm(
                `Mark all ${employees.length} employees as HOLIDAY for ${date}?`
            );


        if (!confirmed) {
            return;
        }


        try {

            setSavingHoliday(true);


            const holidayText =
                holidayName.trim();


            const holidayMap = {};


            // -------------------------------------------------
            // SAVE HOLIDAY FOR EACH EMPLOYEE
            // -------------------------------------------------
            for (const employee of employees) {

                const data = {

                    employeeid:
                        employee.id,

                    shopid:
                        Number(shopid),

                    attendancedate:
                        date,

                    status:
                        "HOLIDAY",

                    intime:
                        "",

                    outtime:
                        "",

                    narration:
                        holidayText

                };


                await axios.post(

                    `${hostlink}/employee-attendance/save`,

                    data

                );


                holidayMap[
                    employee.id
                ] = {

                    status:
                        "HOLIDAY",

                    intime:
                        "",

                    outtime:
                        "",

                    narration:
                        holidayText

                };

            }


            // -------------------------------------------------
            // UPDATE SCREEN
            // -------------------------------------------------
            setAttendance(
                holidayMap
            );


            toast.success(
                `Holiday marked for ${employees.length} employees`
            );


        } catch (error) {

            console.error(error);

            toast.error(
                "Unable to save holiday"
            );

        } finally {

            setSavingHoliday(false);

        }

    };


    // =========================================================
    // COUNTS
    // =========================================================
    const counts = {

        PRESENT:
            Object.values(attendance)
                .filter(
                    x =>
                        x?.status ===
                        "PRESENT"
                )
                .length,

        ABSENT:
            Object.values(attendance)
                .filter(
                    x =>
                        x?.status ===
                        "ABSENT"
                )
                .length,

        HALF_DAY:
            Object.values(attendance)
                .filter(
                    x =>
                        x?.status ===
                        "HALF_DAY"
                )
                .length,

        LEAVE:
            Object.values(attendance)
                .filter(
                    x =>
                        x?.status ===
                        "LEAVE"
                )
                .length,

        HOLIDAY:
            Object.values(attendance)
                .filter(
                    x =>
                        x?.status ===
                        "HOLIDAY"
                )
                .length

    };


    // =========================================================
    // STATUS LIST
    // =========================================================
    const statusList = [

        {
            value: "PRESENT",
            label: "Present",
            icon: "fa-check",
            activeClass:
                "active-present"
        },

        {
            value: "ABSENT",
            label: "Absent",
            icon: "fa-xmark",
            activeClass:
                "active-absent"
        },

        {
            value: "HALF_DAY",
            label: "Half Day",
            icon: "fa-adjust",
            activeClass:
                "active-half_day"
        },

        {
            value: "LEAVE",
            label: "Leave",
            icon: "fa-plane",
            activeClass:
                "active-leave"
        }

    ];


    // =========================================================
    // RETURN
    // =========================================================
    return (

        <div className="container-fluid py-3 attendance-page">


            {/* =================================================
                HEADER
            ================================================= */}

            <div className="page-header mb-3">

                <div className="page-title">

                    <span className="title-icon">

                        <i className="fa-solid fa-calendar-check"></i>

                    </span>


                    <div>

                        <h4>
                            Employee Attendance
                        </h4>

                        <small>
                            Manage daily employee attendance
                        </small>

                    </div>

                </div>


                <div className="date-box">

                    <label>
                        Attendance Date
                    </label>

                    <input
                        type="date"
                        className="form-control"
                        value={date}
                        onChange={e =>
                            setDate(
                                e.target.value
                            )
                        }
                    />

                </div>

            </div>


            {/* =================================================
                HOLIDAY PANEL
            ================================================= */}

            <div className="holiday-panel mb-3">

                <div className="holiday-icon">

                    <i className="fa-solid fa-calendar-days"></i>

                </div>


                <div className="holiday-content">

                    <div className="holiday-title">
                        Holiday Management
                    </div>

                    <div className="holiday-subtitle">
                        Mark all employees as holiday for the selected date
                    </div>

                </div>


                <div className="holiday-input">

                    <input
                        type="text"
                        className="form-control"
                        placeholder="Holiday name e.g. Janmashtami"
                        value={holidayName}
                        onChange={e =>
                            setHolidayName(
                                e.target.value
                            )
                        }
                    />

                </div>


                <button
                    type="button"
                    className="btn holiday-btn"
                    onClick={
                        markAllHoliday
                    }
                    disabled={
                        savingHoliday ||
                        employees.length === 0
                    }
                >

                    {savingHoliday ? (

                        <>
                            <span
                                className="spinner-border spinner-border-sm me-2"
                            ></span>

                            Saving...

                        </>

                    ) : (

                        <>
                            <i className="fa-solid fa-calendar-days me-2"></i>

                            Mark All Holiday
                        </>

                    )}

                </button>

            </div>


            {/* =================================================
                SUMMARY
            ================================================= */}

            <div className="row g-3 mb-3">


                {/* PRESENT */}

                <div className="col-xl col-md-4 col-6">

                    <div className="summary-card">

                        <div className="summary-icon present">

                            <i className="fa-solid fa-check"></i>

                        </div>

                        <div>

                            <small>
                                Present
                            </small>

                            <h4>
                                {counts.PRESENT}
                            </h4>

                        </div>

                    </div>

                </div>


                {/* ABSENT */}

                <div className="col-xl col-md-4 col-6">

                    <div className="summary-card">

                        <div className="summary-icon absent">

                            <i className="fa-solid fa-xmark"></i>

                        </div>

                        <div>

                            <small>
                                Absent
                            </small>

                            <h4>
                                {counts.ABSENT}
                            </h4>

                        </div>

                    </div>

                </div>


                {/* HALF DAY */}

                <div className="col-xl col-md-4 col-6">

                    <div className="summary-card">

                        <div className="summary-icon half">

                            <i className="fa-solid fa-adjust"></i>

                        </div>

                        <div>

                            <small>
                                Half Day
                            </small>

                            <h4>
                                {counts.HALF_DAY}
                            </h4>

                        </div>

                    </div>

                </div>


                {/* LEAVE */}

                <div className="col-xl col-md-4 col-6">

                    <div className="summary-card">

                        <div className="summary-icon leave">

                            <i className="fa-solid fa-plane"></i>

                        </div>

                        <div>

                            <small>
                                Leave
                            </small>

                            <h4>
                                {counts.LEAVE}
                            </h4>

                        </div>

                    </div>

                </div>


                {/* HOLIDAY */}

                <div className="col-xl col-md-4 col-6">

                    <div className="summary-card">

                        <div className="summary-icon holiday">

                            <i className="fa-solid fa-calendar-days"></i>

                        </div>

                        <div>

                            <small>
                                Holiday
                            </small>

                            <h4>
                                {counts.HOLIDAY}
                            </h4>

                        </div>

                    </div>

                </div>

            </div>


            {/* =================================================
                EMPLOYEE CONTAINER
            ================================================= */}

            <div className="employee-container">


                {/* SECTION HEADER */}

                <div className="section-heading">

                    <div>

                        <h5>

                            <i className="fa-solid fa-users me-2"></i>

                            Employees

                        </h5>

                        <span>
                            {employees.length} employees
                        </span>

                    </div>


                    <button
                        type="button"
                        className="btn btn-outline-dark btn-sm"
                        onClick={
                            loadEmployees
                        }
                    >

                        <i className="fa-solid fa-rotate me-1"></i>

                        Refresh

                    </button>

                </div>


                {/* =================================================
                    LOADING
                ================================================= */}

                {loading ? (

                    <div className="text-center py-5">

                        <div className="spinner-border"></div>

                        <div className="loading-text">
                            Loading attendance...
                        </div>

                    </div>

                ) : employees.length === 0 ? (

                    <div className="empty-state">

                        <i className="fa-solid fa-users"></i>

                        <h6>
                            No Employees Found
                        </h6>

                        <p>
                            No employees are available for this shop.
                        </p>

                    </div>

                ) : (

                    <div className="row g-3 p-3">


                        {employees.map(
                            employee => {

                                const current =
                                    attendance[
                                        employee.id
                                    ] || {};

                                const currentStatus =
                                    current.status ||
                                    "";


                                return (

                                    <div
                                        className="col-xl-4 col-lg-6"
                                        key={
                                            employee.id
                                        }
                                    >

                                        <div className="employee-card">


                                            {/* =================================
                                                EMPLOYEE HEADER
                                            ================================= */}

                                            <div className="employee-top">


                                                <div className="employee-avatar">

                                                    {employee.accname
                                                        ?.charAt(0)
                                                        ?.toUpperCase()}

                                                </div>


                                                <div className="employee-name">

                                                    <h6>
                                                        {
                                                            employee.accname
                                                        }
                                                    </h6>

                                                    <small>
                                                        ID #
                                                        {
                                                            employee.id
                                                        }
                                                    </small>

                                                </div>


                                                <div
                                                    className={`status-dot ${
                                                        currentStatus
                                                            ? `status-${currentStatus.toLowerCase()}`
                                                            : ""
                                                    }`}
                                                >

                                                    {currentStatus
                                                        ? currentStatus.replace(
                                                            "_",
                                                            " "
                                                        )
                                                        : "Not Marked"}

                                                </div>

                                            </div>


                                            {/* =================================
                                                HOLIDAY INFORMATION
                                            ================================= */}

                                            {currentStatus ===
                                                "HOLIDAY" && (

                                                <div className="holiday-info">

                                                    <i className="fa-solid fa-calendar-days"></i>

                                                    <span>

                                                        {current.narration ||
                                                            holidayName ||
                                                            "Holiday"}

                                                    </span>

                                                </div>

                                            )}


                                            {/* =================================
                                                STATUS
                                            ================================= */}

                                            <div className="status-label">

                                                Attendance Status

                                            </div>


                                            <div className="attendance-actions">


                                                {statusList.map(
                                                    item => (

                                                        <button
                                                            key={
                                                                item.value
                                                            }
                                                            type="button"
                                                            className={`btn attendance-btn ${
                                                                currentStatus ===
                                                                item.value
                                                                    ? item.activeClass
                                                                    : ""
                                                            }`}
                                                            onClick={() =>
                                                                selectStatus(
                                                                    employee.id,
                                                                    item.value
                                                                )
                                                            }
                                                        >

                                                            <i
                                                                className={`fa-solid ${item.icon} me-1`}
                                                            ></i>

                                                            {
                                                                item.label
                                                            }

                                                        </button>

                                                    )
                                                )}

                                            </div>


                                            {/* =================================
                                                TIME ENTRY
                                            ================================= */}

                                            {currentStatus ===
                                                "PRESENT" && (

                                                <div className="time-entry-box">


                                                    <div className="time-field">

                                                        <label>

                                                            <i className="fa-solid fa-right-to-bracket me-1"></i>

                                                            In Time

                                                        </label>


                                                        <input
                                                            type="time"
                                                            className="form-control"
                                                            value={
                                                                current.intime ||
                                                                ""
                                                            }
                                                            onChange={e =>
                                                                updateAttendanceField(
                                                                    employee.id,
                                                                    "intime",
                                                                    e.target.value
                                                                )
                                                            }
                                                        />

                                                    </div>


                                                    <div className="time-field">

                                                        <label>

                                                            <i className="fa-solid fa-right-from-bracket me-1"></i>

                                                            Out Time

                                                        </label>


                                                        <input
                                                            type="time"
                                                            className="form-control"
                                                            value={
                                                                current.outtime ||
                                                                ""
                                                            }
                                                            onChange={e =>
                                                                updateAttendanceField(
                                                                    employee.id,
                                                                    "outtime",
                                                                    e.target.value
                                                                )
                                                            }
                                                        />

                                                    </div>

                                                </div>

                                            )}


                                            {/* =================================
                                                NARRATION
                                            ================================= */}

                                            {currentStatus !==
                                                "HOLIDAY" && (

                                                <div className="narration-box">

                                                    <label>
                                                        Narration
                                                    </label>

                                                    <input
                                                        type="text"
                                                        className="form-control narration-input"
                                                        placeholder="Optional narration..."
                                                        value={
                                                            current.narration ||
                                                            ""
                                                        }
                                                        onChange={e =>
                                                            updateAttendanceField(
                                                                employee.id,
                                                                "narration",
                                                                e.target.value
                                                            )
                                                        }
                                                    />

                                                </div>

                                            )}


                                            {/* =================================
                                                SAVE BUTTON
                                            ================================= */}

                                            {currentStatus && (
                                                <button
                                                    type="button"
                                                    className="btn save-attendance-btn w-100"
                                                    disabled={
                                                        savingId ===
                                                        employee.id
                                                    }
                                                    onClick={() =>
                                                        saveEmployeeAttendance(
                                                            employee
                                                        )
                                                    }
                                                >

                                                    {savingId ===
                                                    employee.id ? (

                                                        <>

                                                            <span
                                                                className="spinner-border spinner-border-sm me-2"
                                                            ></span>

                                                            Saving...

                                                        </>

                                                    ) : (

                                                        <>

                                                            <i className="fa-solid fa-floppy-disk me-2"></i>

                                                            Save Attendance

                                                        </>

                                                    )}

                                                </button>
                                            )}

                                        </div>

                                    </div>

                                );

                            }
                        )}

                    </div>

                )}

            </div>


            {/* =================================================
                CSS
            ================================================= */}

            <style>{`

                .attendance-page {
                    background: #f5f7fb;
                    min-height: 100vh;
                }


                /* ============================================
                   HEADER
                ============================================ */

                .page-header {
                    background: linear-gradient(
                        135deg,
                        #151c2c,
                        #263b5c
                    );

                    border-radius: 18px;

                    padding: 20px 24px;

                    color: white;

                    display: flex;

                    justify-content: space-between;

                    align-items: center;

                    box-shadow:
                        0 10px 30px
                        rgba(20,30,50,.15);
                }


                .page-title {
                    display: flex;

                    align-items: center;

                    gap: 14px;
                }


                .page-title h4 {
                    margin: 0;

                    font-weight: 700;
                }


                .page-title small {
                    opacity: .7;
                }


                .title-icon {
                    width: 48px;

                    height: 48px;

                    border-radius: 14px;

                    background:
                        rgba(255,255,255,.12);

                    display: flex;

                    align-items: center;

                    justify-content: center;

                    font-size: 21px;
                }


                .date-box {
                    min-width: 210px;
                }


                .date-box label {
                    display: block;

                    font-size: 11px;

                    opacity: .7;

                    margin-bottom: 4px;
                }


                .date-box input {
                    border: 0;

                    border-radius: 10px;

                    padding: 9px 11px;

                    font-size: 13px;
                }


                /* ============================================
                   HOLIDAY PANEL
                ============================================ */

                .holiday-panel {
                    background: white;

                    border: 1px solid #eceff4;

                    border-radius: 16px;

                    padding: 13px 16px;

                    display: flex;

                    align-items: center;

                    gap: 13px;

                    box-shadow:
                        0 5px 20px
                        rgba(0,0,0,.04);
                }


                .holiday-icon {
                    width: 44px;

                    height: 44px;

                    min-width: 44px;

                    border-radius: 12px;

                    background: #f0e8ff;

                    color: #6f42c1;

                    display: flex;

                    align-items: center;

                    justify-content: center;

                    font-size: 18px;
                }


                .holiday-content {
                    flex: 1;

                    min-width: 180px;
                }


                .holiday-title {
                    font-size: 13px;

                    font-weight: 800;

                    color: #202633;
                }


                .holiday-subtitle {
                    font-size: 10px;

                    color: #8b94a4;

                    margin-top: 2px;
                }


                .holiday-input {
                    width: 250px;
                }


                .holiday-input input {
                    font-size: 12px;

                    border-radius: 9px;

                    padding: 9px 11px;
                }


                .holiday-btn {
                    background: #6f42c1;

                    color: white;

                    border: 0;

                    border-radius: 9px;

                    padding: 9px 14px;

                    font-size: 11px;

                    font-weight: 700;

                    white-space: nowrap;
                }


                .holiday-btn:hover {
                    background: #5d35a5;

                    color: white;
                }


                /* ============================================
                   SUMMARY
                ============================================ */

                .summary-card {
                    background: white;

                    border-radius: 15px;

                    padding: 15px;

                    display: flex;

                    gap: 12px;

                    align-items: center;

                    box-shadow:
                        0 5px 20px
                        rgba(0,0,0,.05);

                    height: 100%;
                }


                .summary-card small {
                    color: #8992a3;

                    font-size: 11px;
                }


                .summary-card h4 {
                    margin: 2px 0 0;

                    font-weight: 800;

                    font-size: 21px;
                }


                .summary-icon {
                    width: 43px;

                    height: 43px;

                    min-width: 43px;

                    border-radius: 12px;

                    display: flex;

                    align-items: center;

                    justify-content: center;
                }


                .summary-icon.present {
                    background: #e8f8ee;

                    color: #198754;
                }


                .summary-icon.absent {
                    background: #fdecec;

                    color: #dc3545;
                }


                .summary-icon.half {
                    background: #fff5dc;

                    color: #d99a00;
                }


                .summary-icon.leave {
                    background: #e9efff;

                    color: #4169e1;
                }


                .summary-icon.holiday {
                    background: #f0e8ff;

                    color: #6f42c1;
                }


                /* ============================================
                   EMPLOYEE CONTAINER
                ============================================ */

                .employee-container {
                    background: white;

                    border-radius: 18px;

                    overflow: hidden;

                    box-shadow:
                        0 5px 25px
                        rgba(0,0,0,.05);
                }


                .section-heading {
                    padding: 16px 20px;

                    border-bottom:
                        1px solid #edf0f4;

                    display: flex;

                    justify-content: space-between;

                    align-items: center;
                }


                .section-heading h5 {
                    margin: 0;

                    font-weight: 700;
                }


                .section-heading span {
                    font-size: 12px;

                    color: #8b94a4;
                }


                /* ============================================
                   EMPLOYEE CARD
                ============================================ */

                .employee-card {
                    padding: 17px;

                    border:
                        1px solid #edf0f4;

                    border-radius: 15px;

                    transition: .2s;

                    background: #fff;
                }


                .employee-card:hover {
                    transform:
                        translateY(-2px);

                    box-shadow:
                        0 8px 22px
                        rgba(0,0,0,.07);
                }


                .employee-top {
                    display: flex;

                    align-items: center;

                    gap: 11px;

                    margin-bottom: 14px;
                }


                .employee-avatar {
                    width: 44px;

                    height: 44px;

                    min-width: 44px;

                    border-radius: 50%;

                    background: #edf2ff;

                    color: #4057c9;

                    display: flex;

                    align-items: center;

                    justify-content: center;

                    font-weight: 800;
                }


                .employee-name {
                    flex: 1;

                    min-width: 0;
                }


                .employee-name h6 {
                    margin: 0;

                    font-weight: 700;

                    white-space: nowrap;

                    overflow: hidden;

                    text-overflow: ellipsis;
                }


                .employee-name small {
                    color: #9aa2af;
                }


                /* ============================================
                   STATUS BADGE
                ============================================ */

                .status-dot {
                    font-size: 9px;

                    background: #f4f5f7;

                    color: #8992a0;

                    padding: 5px 8px;

                    border-radius: 20px;

                    white-space: nowrap;
                }


                .status-present {
                    background: #e8f8ee;

                    color: #198754;
                }


                .status-absent {
                    background: #fdecec;

                    color: #dc3545;
                }


                .status-half_day {
                    background: #fff5dc;

                    color: #c48b00;
                }


                .status-leave {
                    background: #e9efff;

                    color: #4169e1;
                }


                .status-holiday {
                    background: #f0e8ff;

                    color: #6f42c1;
                }


                /* ============================================
                   HOLIDAY INFO
                ============================================ */

                .holiday-info {
                    display: flex;

                    align-items: center;

                    gap: 8px;

                    background: #f8f3ff;

                    border:
                        1px solid #eadcff;

                    color: #6f42c1;

                    border-radius: 9px;

                    padding: 8px 10px;

                    margin-bottom: 10px;

                    font-size: 11px;

                    font-weight: 700;
                }


                /* ============================================
                   STATUS BUTTONS
                ============================================ */

                .status-label {
                    font-size: 10px;

                    font-weight: 700;

                    color: #667085;

                    margin-bottom: 7px;
                }


                .attendance-actions {
                    display: grid;

                    grid-template-columns:
                        repeat(2, 1fr);

                    gap: 7px;
                }


                .attendance-btn {
                    border:
                        1px solid #e2e5ea;

                    font-size: 11px;

                    padding: 8px 4px;

                    background: #fff;

                    color: #6d7480;

                    border-radius: 9px;
                }


                .attendance-btn:hover {
                    background: #f6f7f9;
                }


                .active-present {
                    background:
                        #198754 !important;

                    color: white !important;

                    border-color:
                        #198754 !important;
                }


                .active-absent {
                    background:
                        #dc3545 !important;

                    color: white !important;

                    border-color:
                        #dc3545 !important;
                }


                .active-half_day {
                    background:
                        #e0a800 !important;

                    color: white !important;

                    border-color:
                        #e0a800 !important;
                }


                .active-leave {
                    background:
                        #4169e1 !important;

                    color: white !important;

                    border-color:
                        #4169e1 !important;
                }


                /* ============================================
                   TIME ENTRY
                ============================================ */

                .time-entry-box {
                    display: grid;

                    grid-template-columns:
                        1fr 1fr;

                    gap: 8px;

                    margin-top: 12px;

                    padding: 10px;

                    background: #f8fafc;

                    border:
                        1px solid #e9edf3;

                    border-radius: 11px;
                }


                .time-field label,
                .narration-box label {
                    display: block;

                    font-size: 10px;

                    font-weight: 700;

                    color: #667085;

                    margin-bottom: 5px;
                }


                .time-field input {
                    border:
                        1px solid #dfe4ea;

                    border-radius: 8px;

                    font-size: 12px;

                    padding: 7px 8px;

                    background: #fff;
                }


                /* ============================================
                   NARRATION
                ============================================ */

                .narration-box {
                    margin-top: 10px;
                }


                .narration-input {
                    font-size: 11px;

                    border-radius: 9px;

                    border-color: #e2e6eb;

                    padding: 8px 10px;
                }


                /* ============================================
                   SAVE BUTTON
                ============================================ */

                .save-attendance-btn {
                    margin-top: 11px;

                    background: #172554;

                    color: #fff;

                    border: 0;

                    border-radius: 9px;

                    font-size: 11px;

                    font-weight: 700;

                    padding: 9px;
                }


                .save-attendance-btn:hover {
                    background: #0f1b3d;

                    color: white;
                }


                .save-attendance-btn:disabled {
                    opacity: .65;

                    cursor: not-allowed;
                }


                /* ============================================
                   EMPTY / LOADING
                ============================================ */

                .loading-text {
                    color: #8b94a4;

                    font-size: 12px;

                    margin-top: 8px;
                }


                .empty-state {
                    text-align: center;

                    padding: 60px 20px;

                    color: #8b94a4;
                }


                .empty-state i {
                    font-size: 35px;

                    margin-bottom: 12px;

                    opacity: .5;
                }


                .empty-state h6 {
                    color: #4b5563;

                    font-weight: 700;
                }


                .empty-state p {
                    font-size: 12px;

                    margin: 0;
                }


                /* ============================================
                   MOBILE
                ============================================ */

                @media (max-width: 991px) {

                    .holiday-panel {
                        flex-wrap: wrap;
                    }

                    .holiday-content {
                        flex: 1;
                    }

                    .holiday-input {
                        width: 100%;
                        order: 3;
                    }

                    .holiday-btn {
                        margin-left: auto;
                    }

                }


                @media (max-width: 575px) {

                    .page-header {
                        flex-direction: column;

                        align-items: stretch;

                        gap: 15px;
                    }


                    .date-box {
                        min-width: auto;
                    }


                    .holiday-panel {
                        align-items: flex-start;

                        padding: 13px;
                    }


                    .holiday-icon {
                        width: 40px;

                        height: 40px;

                        min-width: 40px;
                    }


                    .holiday-content {
                        min-width: 0;
                    }


                    .holiday-btn {
                        width: 100%;

                        margin-left: 0;

                        order: 4;
                    }


                    .time-entry-box {
                        grid-template-columns:
                            1fr;
                    }


                    .employee-card {
                        padding: 14px;
                    }

                }

            `}</style>

        </div>
    );
};

export default EmployeeAttendance;

